module.exports = __webpack_public_path__ + "static/media/wheel-elgeemedeerei.772c1bd5.png";